import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=bdff063c&scoped=true&"
import script from "./UnitDetail.vue?vue&type=script&lang=js&"
export * from "./UnitDetail.vue?vue&type=script&lang=js&"
import style0 from "./UnitDetail.vue?vue&type=style&index=0&id=bdff063c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdff063c",
  null
  
)

export default component.exports